import { formatCount, formatForum } from "../../lib/format";
import type { ForumSummary } from "../../api/types";

export interface ForumBreakdownListProps {
  data: ForumSummary[];
}

/** Plain magnitude comparison across forums - one hue, not identity, so a single shade is used throughout. */
export function ForumBreakdownList({ data }: ForumBreakdownListProps) {
  const maxCount = Math.max(1, ...data.map((d) => d.count));

  return (
    <div className="space-y-2.5">
      {data.map((row) => {
        const pct = Math.max(6, Math.round((row.count / maxCount) * 100));
        return (
          <div key={row.recommended_forum} className="flex items-center gap-3">
            <div className="w-36 shrink-0 truncate text-sm text-slate-700">{formatForum(row.recommended_forum)}</div>
            <div className="h-3 flex-1 rounded bg-slate-100">
              <div className="h-3 rounded-r bg-brand-500" style={{ width: `${pct}%` }} />
            </div>
            <div className="w-8 shrink-0 text-right font-mono text-sm tabular-nums text-slate-600">{formatCount(row.count)}</div>
          </div>
        );
      })}
    </div>
  );
}
